import React from "react";
import { connect } from "react-redux";
//
import { formatTime } from "../services/date";
import Screen from "./ConnectedScreen";
import Button from "../components/Button";

function VerifyEmailScreen({ email, sendEmailOtp, errorMessage }) {
  return (
    <Screen title="One last step..." onBack={false} isActive noFooter>
      <p className="u-mv">
        One extra step before confirming your booking, we need to verify your
        email address: <span className="u-brand">{email}</span>.
      </p>
      <p>
        Click the button below in order to send a unique OTP to your email
        address.
      </p>
      <div className="u-tc">
        <Button
          title="Send OTP"
          onClick={sendEmailOtp}
          className="u-ml-small"
        />
      </div>
      {errorMessage !== null && (
        <p className="u-danger u-small u-mt">{errorMessage}</p>
      )}
    </Screen>
  );
}

// @connect
import { sendEmailOtpAction } from "../modules/booking/actions";

function mapState(state, props) {
  const { booking } = state;

  return {
    email: booking.email,
  };
}

function mapDispatch(dispatch) {
  return {
    sendEmailOtp() {
      dispatch(sendEmailOtpAction());
    },
  };
}

export default connect(
  mapState,
  mapDispatch
)(VerifyEmailScreen);
